import classNames from 'classnames'
import { CSSProperties, ReactNode, useState } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import cn from './index.module.css'
import dayjs from 'dayjs'
import { DatePicker, DatePickerProps } from 'antd'
import { RangePickerProps } from 'antd/es/date-picker'
import { getAvatar } from '@/helpers/getAvatar'

export const TextCell = ({
  text = '',
  className = '',
  wrapperClassname = '',
  styles = undefined,
  wrapperStyles = undefined,
  onClick = undefined,
}: {
  text: string
  wrapperClassname?: string
  className?: string
  styles?: CSSProperties
  wrapperStyles?: CSSProperties
  onClick?: () => void
}) => {
  return (
    <div
      className={classNames(cn.cellWrapper, wrapperClassname)}
      style={wrapperStyles}
    >
      <div
        className={classNames(cn.textCell, className)}
        onClick={onClick}
        style={{
          cursor: onClick != undefined ? 'pointer' : 'default',
          ...styles,
        }}
      >
        {text}
      </div>
    </div>
  )
}

export const UserCell = ({
  name = '',
  icon = '',
  className = '',
  wrapperClassname = '',
  styles = undefined,
  wrapperStyles = undefined,
  onClick = undefined,
}: {
  name: string
  icon?: string | null
  wrapperClassname?: string
  className?: string
  styles?: CSSProperties
  wrapperStyles?: CSSProperties
  onClick?: () => void
}) => {
  return (
    <div
      className={classNames(cn.cellWrapper, wrapperClassname)}
      style={wrapperStyles}
      onClick={onClick}
    >
      <img className={cn.userAvatar} src={getAvatar(icon)} alt={'user photo'} />
      <div
        className={classNames(cn.textCell, className)}
        style={{
          cursor: onClick != undefined ? 'pointer' : 'default',
          ...styles,
        }}
      >
        {name}
      </div>
    </div>
  )
}

export const InputDateCell = ({
  date = '',
  disabledDate = undefined,
  className = '',
  styles = undefined,
  disabled = false,
  onChange,
}: {
  date: string | null
  disabledDate?: RangePickerProps['disabledDate']
  className?: string
  styles?: CSSProperties
  disabled?: boolean
  onChange: (date: string) => void
}) => {
  const [dateValue, setDateValue] = useState<dayjs.Dayjs | null>(
    date ? dayjs(date) : null,
  )
  const onValueChange: DatePickerProps['onChange'] = (date, dateString) => {
    setDateValue(date)
    onChange(dateString)
  }

  return (
    <DatePicker
      className={classNames(cn.cellWrapper, cn.datePickerCell, className)}
      style={styles}
      value={dateValue}
      format="DD.MM.YYYY"
      disabledDate={disabledDate}
      onChange={onValueChange}
      disabled={disabled}
    />
  )
}

export const InputTextAreaCell = ({
  text = '',
  className = '',
  wrapperClassname = '',
  styles = undefined,
  wrapperStyles = undefined,
  disabled = false,
  onChange,
}: {
  text: string
  wrapperClassname?: string
  className?: string
  styles?: CSSProperties
  wrapperStyles?: CSSProperties
  disabled?: boolean
  onChange: (value: string) => void
}) => {
  return (
    <div className={classNames(wrapperClassname)} style={wrapperStyles}>
      <textarea
        className={classNames(cn.cellWrapper, cn.inputTextAreaCell, className)}
        style={styles}
        onChange={(e) => onChange(e?.target?.value)}
        defaultValue={text}
        disabled={disabled}
      />
    </div>
  )
}

export const IconButtonCell = ({
  icon = (
    <CloseOutlined
      onPointerEnterCapture={undefined}
      onPointerLeaveCapture={undefined}
    />
  ),
  className = '',
  onClick = undefined,
}: {
  icon: ReactNode
  className?: string
  onClick?: () => void
}) => {
  return (
    <button
      className={classNames(cn.cellWrapper, cn.iconButtonCell, className)}
      onClick={onClick}
    >
      {icon}
    </button>
  )
}
